import { useEffect, useState } from 'react';

const useVersionCheck = (checkInterval = 60000) => { // Check every minute by default
  const [updateAvailable, setUpdateAvailable] = useState(false);
  
  useEffect(() => {
    let currentVersion = null;

    const checkVersion = async () => {
      try {
        // Fetch with cache-busting query parameter
        const response = await fetch(`/version.json?t=${Date.now()}`, {
          cache: 'no-cache',
          headers: {
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache'
          }
        });
        
        if (response.ok) {
          const data = await response.json();
          
          if (currentVersion === null) {
            // First check - store the current version
            currentVersion = data.version;
          } else if (currentVersion !== data.version) {
            // Version has changed
            setUpdateAvailable(true);
          }
        }
      } catch (error) {
        console.error('Version check failed:', error);
      }
    };

    // Check immediately
    checkVersion();

    // Set up interval
    const interval = setInterval(checkVersion, checkInterval);

    return () => clearInterval(interval);
  }, [checkInterval]);

  const reloadApp = () => {
    // Clear caches and reload
    if ('caches' in window) {
      caches.keys().then(names => {
        names.forEach(name => {
          caches.delete(name);
        });
      }).then(() => {
        window.location.reload(true);
      });
    } else {
      window.location.reload(true);
    }
  };

  return { updateAvailable, reloadApp };
};

export default useVersionCheck;